// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.cover-select-spinner{position:absolute;top:50%;left:50%;margin-top:-50px;margin-left:-50px;width:100px;height:100px}.cover-select-parent{display:flex}.cover-select-child{flex:1;margin:10px}@media (max-width: 768px){.cover-select-child{display:none}.cover-select-child.selected{display:block}}.cover-select-child:first-child{margin-right:20px;text-align:center !important}\n", ""]);
// Exports
module.exports = exports;
